import { Component, Input, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-user-guide',
    templateUrl: './user-guide.component.html',
    styleUrls: ['./user-guide.component.scss'],
    standalone: false
})
export class UserGuideComponent implements OnInit {

  @Input() public guide: string;

  constructor(
    public modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  openUserGuide(modal: TemplateRef<any>): void {
    this.modalService.open(modal, { size: 'lg' });
  }

}
